"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleTransactionSelectorStyles = exports.WFBillScoutStyles = void 0;
const bodyHeight = 460;
const WFBillScoutStyles = (theme) => {
    const { spacing, palette, typography } = theme;
    return ({
        dialog: {
            maxWidth: 850,
            minWidth: 750,
        },
        qCard: {
            zIndex: 5000,
        },
        headlineTitle: Object.assign({}, typography.h6),
        headlineCaption: Object.assign({}, typography.subtitle1),
        body: {
            flex: 1,
            height: bodyHeight,
            padding: `0 ${spacing(3.25)}`,
        },
        bodyTxnSelector: {
            paddingTop: 0,
            alignItems: 'flex-end',
            flexDirection: 'column',
        },
        actions: {
            backgroundColor: palette.background.input,
            margin: spacing(-2, 3.25, 0),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            height: 80,
            borderTop: `1px solid ${palette.border.default}`,
            position: 'relative',
        },
        wideButton: {
            padding: spacing(0.75, 4),
        },
        backButton: {
            marginRight: spacing(2),
        },
        skipButton: {
            marginRight: spacing(2),
        },
        continueButton: {
            color: `${palette.secondary.contrastText} !important`,
        },
        searchBarRoot: {
            display: 'inline-block',
            margin: `0 0 ${spacing()}`,
        },
        searchBar: {
            paddingLeft: 4,
            borderRadius: 4,
            margin: 0,
            '&.open': {
                width: 196,
            },
        },
        searchInput: {
            fontSize: '14px',
            lineHeight: 1.43,
            fontWeight: 'normal',
        },
        searchIcon: {
            color: palette.secondary.main,
        },
        cancelIcon: {
            color: palette.text.tertiary,
        },
        editScheduledTransactionLabel: Object.assign(Object.assign({}, typography.caption), { textAlign: 'left', width: '100%', display: 'inline-block' }),
        manualLine: Object.assign(Object.assign({}, typography.body2), { textAlign: 'left', width: '100%' }),
        manualAddLine: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            color: theme.palette.secondary.main,
        },
        manualButton: {
            color: theme.palette.secondary.main,
            marginLeft: 6,
        },
        helperLine: Object.assign(Object.assign({}, typography.caption), { fontWeight: typography.fontWeightMedium, textAlign: 'left', width: '100%' }),
        backLine: {
            textAlign: 'left',
            width: '100%',
        },
    });
};
exports.WFBillScoutStyles = WFBillScoutStyles;
const ScheduleTransactionSelectorStyles = ({ spacing, palette, typography }) => ({
    zeroRoot: {
        margin: '0 auto',
    },
    waiterRoot: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    waiterTitle: Object.assign(Object.assign({}, typography.subtitle1), { marginTop: 0 }),
    waiterText: Object.assign({}, typography.body2),
    waiterCircularRoot: {
        textAlign: 'center',
    },
    scheduleTxnSelectorRoot: {
        flex: 1,
        flexDirection: 'column',
        flexWrap: 'nowrap',
        height: '100%',
        marginTop: spacing(),
        maxHeight: bodyHeight,
        minHeight: 400,
    },
    selectTitle: Object.assign(Object.assign({}, typography.body2), { width: spacing(8), textAlign: 'center' }),
    scheduleTxnSelectorWrapper: {
        flex: 1,
        maxHeight: '100%',
        overflow: 'scroll',
        width: '100%',
        borderTop: `1px solid ${palette.border.default}`,
    },
    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 6px',
    },
    standardRow: {
        background: palette.background.sunken,
        borderRadius: 10,
        '& td:first-of-type': {
            borderRadius: '10px 0 0 10px',
        },
        '& td:last-of-type': {
            borderRadius: '0 10px 10px 0',
        },
        // '&:hover': {
        //   backgroundColor: palette.state.hover.default,
        // },
    },
    tableCellRoot: {
        borderBottom: 'none',
    },
    tableCell: {
        padding: `${spacing(1.5)} ${spacing(1)} ${spacing(1.5)}`,
        height: spacing(11.75),
    },
    tableCellAvatar: {
        height: spacing(11.75),
        padding: spacing(2),
        paddingRight: spacing(0.5),
        maxWidth: spacing(25),
    },
    tableCellActions: {
        height: spacing(11.75),
        padding: `${spacing(2)} ${spacing(1)} ${spacing(2)} !important`,
    },
    tableCellContent: {
        display: 'flex',
        flexDirection: 'column',
    },
    tableCellAvatarContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    tableCellPayeeContent: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: spacing(25),
    },
    tableCellAmountContent: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: spacing(18),
    },
    tableCellAccountContent: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: spacing(20),
    },
    tableCellActionsContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        maxWidth: spacing(18),
    },
    cellTitle: Object.assign(Object.assign({}, typography.body1), { display: 'block', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', textAlign: 'left', width: '100%' }),
    cellCaption: Object.assign(Object.assign({}, typography.caption), { display: 'block' }),
    avatar: {
        borderRadius: 3,
    },
    selectIcon: {
        color: palette.secondary.main,
        border: `1px solid ${palette.text.tertiary}`,
        borderRadius: '50%',
    },
    selectedIcon: {
        color: palette.secondary.main,
    },
    bottomActionsTitleContainer: {
        flexDirection: 'column',
        padding: spacing(2, 0, 2.5),
        borderTop: `2px solid ${palette.divider}`,
    },
    collapseArea: {
        width: '100%',
    },
    collapseAreaWrapper: {
        width: '100%',
    },
    missingTypeTitleTop: Object.assign(Object.assign({}, typography.subtitle1), { fontWeight: typography.fontWeightLight, display: 'inline-block' }),
    bottomActionsRoot: {
        justifyContent: 'space-evenly',
        paddingTop: spacing(2),
    },
    actionContainer: {
        padding: `${spacing(1)} ${spacing(1)} ${spacing(4)} ${spacing(2)}`,
        flexDirection: 'column',
        justifyContent: 'space-between',
        flex: 1,
        maxWidth: '100%',
    },
    addMissingContainer: {
        padding: `${spacing(1)} ${spacing(1)} ${spacing(4)} ${spacing(2)}`,
        flexDirection: 'column',
        justifyContent: 'space-between',
        flex: 1,
        maxWidth: '100%',
    },
    wideButton: {
        padding: spacing(0.75, 2.5),
        borderColor: palette.border.light,
        marginRight: spacing(),
        '&:last-child': {
            marginLeft: spacing(),
        },
    },
});
exports.ScheduleTransactionSelectorStyles = ScheduleTransactionSelectorStyles;
